import { t } from '@vk-hr-tek/core/translations/t';

import { NicknameKeys } from '../../types';

export const SIDEBAR_TITLES: () => Record<NicknameKeys, string> = () => ({
  main: t('modules.Dashboard.dashboard.companyTitle'),
  news: t('modules.News.news.employeeTitle'),
  surveys: t('modules.Surveys.surveys.employeeTitle'),
  company_target_audience: t(
    'modules.TargetAudience.target-audience.employeeTitle',
  ),
  community: t('modules.Community.community.companyTitle'),
  favorites: t('modules.Favorites.favorites.companyTitle'),
  feed: t('modules.Feed.feed.companyTitle'),
  dropdown_social_life: t('modules.SocialLife.social-life.companyTitle'),
  structure: t('modules.Organization.organization.companyTitle'),
  process_catalog: t('modules.ProcessCatalog.process-catalog.companyTitle'),
  company_events: t('modules.Events..companyTitle'),
  dropdown_company_events: t('modules.Events.events.companyTitle'),
  company_events_paper: t('modules.Events.paper.companyTitle'),
  company_policy: t('modules.Policy.policy.companyTitle'),
  company_absences: t('modules.Absences.absences.companyTitle'),
  company_vacations: t('modules.Vacations.vacations.companyTitle'),
  company_employees: t('modules.Employees.employees.companyTitle'),
  company_candidates: t('modules.Candidates.candidates.companyTitle'),
  employee_personal: t('modules.Personal.personal.employeeTitle'),
  employee_events: t('modules.Events.events.employeeTitle'),
  employee_policy: t('modules.Policy.policy.employeeTitle'),
  employee_absences: t('modules.Absences.absences.employeeTitle'),
  employee_payslips: t('modules.Payslips.payslips.employeeTitle'),
  employee_vacations: t('modules.Vacations.vacations.employeeTitle'),
  employee_competencies: t('modules.Competencies.competencies.employeeTitle'),
  employee_review: t('modules.Review.review.employeeTitle'),
  company_review: t('modules.Review.review.companyTitle'),
  dropdown_company_settings: t('modules.Settings.settings.companyTitle'),
  dropdown_social_services: t(
    'modules.SocialServices.social-services.companyTitle',
  ),
  company_social_quiz: t('modules.Quiz.quiz.companyTitle'),
  company_settings: t('modules.Settings.company.companyTitle'),
  company_settings_account: t('modules.Settings.account.companyTitle'),
  company_settings_widgets_content: t(
    'modules.Settings.widgets-content.companyTitle',
  ),
  company_settings_event_types: t('modules.Settings..companyTitle'),
  company_settings_templates: t('modules.Settings.templates.companyTitle'),
  company_settings_groups: t('modules.Settings.groups.companyTitle'),
  company_settings_profiles: t('modules.Settings.profiles.companyTitle'),
  company_settings_substitutes: t('modules.Settings.substitutes.companyTitle'),
  company_settings_vacations: t('modules.Settings.vacations.companyTitle'),
  company_settings_attorneys: t('modules.Settings.attorneys.companyTitle'),
  company_settings_attorneys_users: t(
    'modules.Settings.attorneys-users.companyTitle',
  ),
  company_settings_sign_types: t('modules.Settings.sign-types.companyTitle'),
  company_social_news: t('modules.News.news.companyTitle'),
  company_social_categories: t(
    'modules.Categories.social-categories.companyTitle',
  ),
  company_social_access: t('modules.SocialAccess.social-access.companyTitle'),
  company_services: t('dashboard.constants.companyServices'),
  employee_services: t('dashboard.constants.employeeServices'),
  company_business_trips: t(
    'modules.BusinessTrips.business-trips.companyTitle',
  ),
  employee_business_trips: t(
    'modules.BusinessTrips.business-trips.employeeTitle',
  ),
});
